import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form} from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncUpdate, asyncAdd, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class Edit extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    //先注释下面代码 否则修改不了脚本级别
                    // if (!values[i]) {
                    //     delete values[i];
                    // }
                }
                if (this.props.item.scriptId === undefined) {
                    await this.props.asyncAdd(formatFormData(values));
                } else {
                    await this.props.asyncUpdate(formatFormData(values));
                }
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.changeCurrentSelectId();
                this.props.asyncGet();
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="脚本ID">
                            {getFieldDecorator('scriptId', {
                                initialValue: item.scriptId || '0',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入脚本ID ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} disabled />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="脚本名称">
                            {getFieldDecorator('scriptName', {
                                initialValue: item.scriptName || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入脚本名称 ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="下载地址">
                            {getFieldDecorator('downloadUrl', {
                                initialValue: item.downloadUrl || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入下载地址',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="存放路径">
                            {getFieldDecorator('savePath', {
                                initialValue: item.savePath || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入存放路径',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="适用系统">
                            {getFieldDecorator('applySys', {
                                initialValue: item.applySys || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请选择适用系统',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="android">android</Option>
                                    <Option value="ios">ios</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="脚本类型">
                            {getFieldDecorator('source', {
                                initialValue: item.source || '',
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择脚本类型',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择">
                                    <Option value="PHANTOMJS">PHANTOMJS</Option>
                                    <Option value="CHROMIUM">CHROMIUM</Option>
                                    <Option value="CHROME">CHROME</Option>
                                    <Option value="APP">APP</Option>
                                    <Option value="APPLAUNCH">APPLAUNCH</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="脚本级别">
                            {getFieldDecorator('scriptType', {
                                initialValue: item.scriptType,
                                rules: [
                                    {
                                        required: true,
                                        message: '',
                                    },
                                ],
                            })(
                                <Select style={{ width: '100%' }} >
                                    <Option value={1}>主脚本</Option>
                                    <Option value={0}>子脚本</Option>
                                </Select>,
                                )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="脚本内容">
                            {getFieldDecorator('scriptContent', {
                                initialValue: item.scriptContent || '',
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入',
                                    },
                                ],
                            })(
                                <TextArea rows={4} placeholder="请填写脚本内容" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.scriptList.list.reduce((a, b) => (b.scriptId === state.scriptList.currentSelectId ? b : a), {}),
    isModalShow: state.scriptList.uiStatus.isUpdateShow,
    isLoading: state.scriptList.uiStatus.isLoading,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncAdd: contents => dispatch(asyncAdd(contents)),
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelectId: () => dispatch(actions.changeCurrentSelectId('')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/client/scriptList/edit.js